module.exports = __webpack_public_path__ + "static/media/footer-tab.a6ae2847.png";